<!-- @format -->

<ng-container *ngIf="!review?.IsSyndicated; else isSyndicated">
	<ng-container [ngTemplateOutlet]="isLoading ? skeletonShapes : nonSyndicated"> </ng-container>
</ng-container>

<ng-template #skeletonShapes>
	<div class="hmf-mt-s">
		<div class="hmf-mb-xs hmf-display-lg-none">
			<div class="hmf-display-flex hmf-align-items-center hmf-justify-content-between">
				<ng-container *skeletonLoader="isLoading; type: skeletonShape.MEDIUM_TEXT">
				</ng-container>

				<ng-container *skeletonLoader="isLoading; type: skeletonShape.EXTRA_SMALL_TEXT">
				</ng-container>
			</div>
		</div>

		<div class="hmf-mb-s hmf-display-none hmf-display-lg-block">
			<div
				class="hmf-display-flex hmf-align-items-center hmf-align-self-start hmf-justify-content-between">
				<ng-container *skeletonLoader="isLoading; type: skeletonShape.WIDE_TEXT">
				</ng-container>

				<ng-container *skeletonLoader="isLoading; type: skeletonShape.MEDIUM_TEXT">
				</ng-container>
			</div>
		</div>
	</div>
</ng-template>

<ng-template #nonSyndicated>
	<div
		class="hmf-display-flex hmf-align-items-center hmf-align-self-start hmf-justify-content-between">
		<div
			class="hmf-display-flex hmf-align-items-center hmf-align-self-start hmf-justify-content-between hmf-body-s hmf-body-m-m">
			<div class="hmf-mr-xs hmf-mr-m-m">Helpful?</div>
			<div class="hmf-mr-xxs">
				<button
					id="like-button"
					class="button-vote-container hmf-p-0"
					name="like-button"
					aria-label="Like this review"
					[disabled]="stateButtons.vote"
					(click)="voteButtonClicked(voteType.POSITIVE)">
					<homefield-icon
						name="reaction-like"
						width="20"
						height="20"
						[fill]="iconColors.like">
					</homefield-icon>
				</button>
			</div>
			<p class="hmf-mr-xs hmf-mr-m-m hmf-mb-0">{{ totalCounts.positive }}</p>
			<div class="hmf-mr-xxs">
				<button
					id="dislike-button"
					class="button-vote-container hmf-p-0"
					name="dislike-button"
					aria-label="Dislike this review"
					[disabled]="stateButtons.vote"
					(click)="voteButtonClicked(voteType.NEGATIVE)">
					<homefield-icon
						name="reaction-dislike"
						width="20"
						height="20"
						[fill]="iconColors.dislike">
					</homefield-icon>
				</button>
			</div>
			<p class="hmf-m-0">{{ totalCounts.negative }}</p>
		</div>
		<button
			class="button-report-container hmf-p-0"
			id="report-button"
			[disabled]="stateButtons.report"
			(click)="reportButtonClicked()">
			{{ labelReport }}
		</button>
	</div>
</ng-template>

<ng-template #isSyndicated>
	<div
		class="content-syndicated hmf-display-flex hmf-align-items-center hmf-align-self-start hmf-justify-content-between"
		[ngClass]="{ 'hmf-display-none': isLoading }">
		<div class="hmf-p-xxs hmf-body-s hmf-body-m-m">
			<img
				[src]="review?.SyndicationSource?.LogoImageUrl"
				class="image-syndicated hmf-mr-xs"
				alt="{{ review?.SyndicationSource?.Name }} logo" />
			Originally posted on {{ review?.SyndicationSource?.Name ?? '' }}
		</div>
	</div>
</ng-template>
